import { render, staticRenderFns } from "./TopSidebar.vue?vue&type=template&id=cfb72eb2&scoped=true&"
import script from "./TopSidebar.vue?vue&type=script&lang=js&"
export * from "./TopSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TopSidebar.vue?vue&type=style&index=0&id=cfb72eb2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb72eb2",
  null
  
)

export default component.exports